import React from 'react'

export default function RishikeshVideo() {
  return (
    <>
    <section className="rishikesh-video">
        <video autoPlay loop muted playsInline controls poster="/image/rish-videothumb.webp">
            <source src="/video/rishikesh-video.mp4" type="video/mp4"/>
        </video>
    </section> 
    </>
  )
}
